import React, {PureComponent} from 'react';

import { Tabs, Tab } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';

import Drivers from './Drivers';
import Admins from './Admins';
import Psychologists from './Psychologists';

import './Users.css';
export default injectIntl(class AdminDashboard extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeTabIndex: 0,
    };
  }

  handleTabChange = (activeTabIndex) => {
    this.setState({activeTabIndex});
  }

  render(){
    const {activeTabIndex} = this.state;
    const {intl, ...childProps} = this.props

    return (
      <div className="tabs-container">
        <Tabs
          tabId="users-tabs"
          onTabChange={this.handleTabChange}
        >
          <Tab label={intl.formatMessage({ id: 'adminDashboard.tabs.drivers' })}/>
          <Tab label={intl.formatMessage({ id: 'adminDashboard.tabs.psychologists' })}/>
          <Tab label={intl.formatMessage({ id: 'adminDashboard.tabs.admins' })}/>

        </Tabs>
        {
          activeTabIndex === 0 ? <Drivers {...childProps}/>
          : activeTabIndex === 1 ? <Psychologists {...childProps}/>
          : activeTabIndex === 2 ? <Admins {...childProps} />
          : false
        }
      </div>
    )
  };
});



// WEBPACK FOOTER //
// ./src/components/Users/index.js